import React, { useRef, useState, useEffect } from 'react';

import './fadein.css';

const FadeIn = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsVisible(scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`fade-toggle ${isVisible ? 'visible' : ''}`}>
      {children}
    </div>
  );
};

export default FadeIn;